import React from "react";
import PanelGroupController from "../../components/PanelGroupController";
import {cx} from "../../lib/ClassSet";
import {isInTransit} from "../../lib/FulfillmentStatus";
import gql from "graphql-tag";
import {graphql} from "react-apollo";
import "./ShippingStatusPanel.scss";

const ShippingStatusPanel = (props) => {

  if (props.loading || props.error) return null;
  if (!props.data.shippingOrder) return null;
  let status = props.data.shippingOrder.fulfillmentStatus;

  if (status === "cancelled") {
    return (
      <div className="ShippingStatusPanel">
        <p>Order has been cancelled</p>
      </div>
    )
  }

  return (
    <div className="ShippingStatusPanel">
      <PanelGroupController title="Fulfillment Status" expanded={true}>
        <State key="preparation" title="Preparation" current={status === "preparation"} />
        <State key="ready" title="Ready" current={status === "ready"} />
        <State key="packaging" title="Packaging" current={status === "packaging"} />
        <State key="dispatch" title="Dispatch" current={status === "dispatch"} />
        <State key="delivery" title="Delivery" current={isInTransit(status)} />
        <State key="delivered" title="Delivered" current={status === "delivered"} />
      </PanelGroupController>
    </div>
  )

}

const ORDER_STATUS_ID = gql`
  query shippingOrder($orderId:ID!) {
    shippingOrder(orderId:$orderId) {
      fulfillmentStatus
    }
  }
`;

const withQuery = graphql(ORDER_STATUS_ID, {
  options: (props) => ({
    fetchPolicy: "cache-only",
    variables: {
      orderId: props.orderId
    }
  })
})


export default withQuery(ShippingStatusPanel);

const State = (props) => {

  let classes = cx({
    "State": true,
    "u-current": props.current,
    "u-completed": props.completed
  })

  return (
    <div className={classes}>
      <div className="title">{props.title}</div>
    </div>
  )

}